import React from "react"
import Layout from "../components/layout"
import Img from "gatsby-image"
import SEO from "../components/seo"
import Container from "../components/container"
import styled from "@emotion/styled"
import moment from "moment";

import {
  Twitter, 
  Facebook, 
  Mail, 
  Reddit, 
} from 'react-social-sharing'

import { BLOCKS, MARKS } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import {
  Box, 
  Heading, 
  Grid, 
  Text, 
  Button,
  Image, 
  Divider, 
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  useDisclosure, 
} from "@chakra-ui/core";

// import theme from "../theme";

const Styles = styled.div`
    // box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
    // grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));

    min-height: 60vh;

    .my-box {
      a {
        margin: 0px;
      }
  
      .my-link {
        margin: 0px;
        font-size: 14px;
        border-radius: 2px;
        padding: 2px 6px;
        margin-right: 4px;
        margin-bottom: 4px;
      }
    }

`

export default class extends React.Component {
  constructor ( props ) {
    super();
    this.state = {};
    this.state.node = props.pageContext.node; 
  } 

  componentDidMount () {
    var disqus_config = function () {
      this.page.url = this.state.node.slug;  // Replace PAGE_URL with your page's canonical URL variable
      this.page.identifier = this.state.node.id; // Replace PAGE_IDENTIFIER with your page's unique identifier variable
      };
      (function() { // DON'T EDIT BELOW THIS LINE
      var d = document, s = d.createElement('script');
      s.src = 'https://prolific-coast-seeds.disqus.com/embed.js';
      s.setAttribute('data-timestamp', +new Date());
      (d.head || d.body).appendChild(s);
      })();
  }

  blogImage (el) {
    // check for image
    return (
      <Box data-id={el.id} minHeight="180px" overflow="hidden" cursor="pointer" onClick={ this.magnify.bind(this)} maxHeight="220px">
        <Img fluid={ el.fluid } style={{minHeight: "180px", height: "16vw", maxHeight: "180px"}}/>
      </Box>
    )
  }

  magnify (e) {

    let image = this.state.node.resources.filter( (el) => {
      return el.id == e.currentTarget.dataset.id 
    })
    debugger
    this.setState({
      activeImage: image[0].fluid
    })
    document.querySelectorAll(".image-modal")[0].click();
  }

  render() {
    let options = {
      renderMark: {
        [MARKS.BOLD]: text => <Text fontWeight="bold">{text}</Text>,
        [MARKS.ITALIC]: text => <Text fontStyle="italic">{text}</Text>,
        [MARKS.UNDERLINE]: text => <Text textDecoration="underline">{text}</Text>,
        // [INLINES.HYPERLINK]: (text) => <ChakraLink>{text}</ChakraLink>,
      },
      renderNode: {
        [BLOCKS.PARAGRAPH]: (node, children) => <Text mb={2}>{children}</Text>,
        [BLOCKS.HEADING_1]: (node, children) => <Heading>{children}</Heading>,
        [BLOCKS.HEADING_3]: (node, children) => <Heading size="md">{children}</Heading>,
        [BLOCKS.HEADING_4]: (node, children) => <Heading size="md" mb={2}>{children}</Heading>,
        [BLOCKS.HEADING_6]: (node, children) => <Heading size="sm">{children}</Heading>,
        [BLOCKS.HR]: (node, children) => <Divider />,
        // [INLINES.HYPERLINK]: (node, children) => {
        //   return <ChakraLink href={node.data.uri} target="_blank" rel="noopender noreferrer"> {node.content[0].value} </ChakraLink>
        // },
        [BLOCKS.EMBEDDED_ASSET]: (node) => {
          return <Box height="160px" width="160px" my={2}>

            <Image height="100%" width="100%" objectFit="cover" src={ node.data.target.fields.file["en-US"].url } alt={ node.data.target.fields.file["en-US"].url } />

          </Box>
        },
      },
    }
    return (
      <Layout >
        <SEO title={ this.state.node.title } />
        <ImageModal parent={ this } />
        <Styles>

        <Box bg="gray.100" pt="40px">

            <Container >
            
              <Grid templateColumns={["repeat(100%)", "repeat(100%)", "280px calc(100% - 280px)"]} gap={[4, 4, "0px"]} mb={4}>
                <Box >
                  <Box cursor="pointer" data-id={this.state.node.resources[0].id } height={["280px", "400px", "280px" ]} rounded="none" overflow="hidden" rounded="sm" mb={2} onClick={ this.magnify.bind(this)}>
                  <Img  fluid={ this.state.node.resources[0].fluid } style={{height: "100%"}}  />
                  </Box>

                </Box>

                <Box pl={["0", "0", "32px"]} >

                  <Heading mb={2}>{ this.state.node.title }</Heading>
               


                  <Box mb={2}>
                  <Box className="my-box" display="inline-block" >
                    <Mail size="medium" link={"https://prolificcoastseends.com/" + this.state.node.slug } className="my-link" />
                  </Box>


                  <Box className="my-box" display="inline-block" >
                   <Facebook size="medium" link={"https://prolificcoastseends.com/" + this.state.node.slug } className="my-link" />
                  </Box>

                  <Box className="my-box" display="inline-block" >
                    <Twitter size="medium" link={"https://prolificcoastseends.com/" + this.state.node.slug } className="my-link" />
                  </Box>

                  <Box className="my-box" display="inline-block" >
                  <Reddit size="medium" link={"https://prolificcoastseends.com/" + this.state.node.slug } className="my-link" />
                  </Box>
                  </Box>



                  <Box mb={2} fontSize="18px" fontWeight="bold">
                      { new moment(this.state.node.createdAt).format("MMMM Do YYYY") }
                  </Box>
                   

                  <Text mb={2} >
                    { documentToReactComponents( this.state.node.body.json, options ) } 
                  </Text>

                  

                </Box>
              </Grid>

              </Container>

              <Container>


              <Grid templateColumns="repeat(auto-fill, minmax(180px, 1fr))" gap={4} mb={6}>
                    {
                      this.state.node.resources.slice(1).map( this.blogImage.bind(this) )
                    }

                  </Grid>
                  </Container>

           
              {/* <Box>
                <Container >
                <video width="100%" height="500" controls>
                   <source src={ this.state.node.titleVideo.file.url } type="video/mp4" />
                </video>
                </Container>
              </Box>  */}


              <Box bg={"gray.200"} color="gray.900" borderTopColor={ "gray.900" } borderTopWidth="1px">
              <Container>

                <div id="disqus_thread"></div>
              </Container>
              </Box>

        </Box>

        </Styles>
      </Layout>
    )
  }
}

// export const query = graphql`
//   {
//     search: allContentfulCatalog {
//       nodes {
//         id
//         body {
//           body
//         }
//         title
//         price
//         slug
//         phenotypeInfo
//         finishTime  
//       }
//     }
//   }
// `

function ImageModal ( props ) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <Button onClick={onOpen} className="image-modal" opacity="0" height="0px" position="absolute"></Button>

      <Modal isOpen={isOpen} onClose={onClose} >
        <ModalOverlay />
        <ModalContent  rounded="md" overflow="hidden"  minWidth={"50vw"} minHeight={"50vh"}>
          <ModalBody   padding={[4, 6]} rounded="sm" overflow="hidden" >
            <Img fluid={ props.parent.state.activeImage } style={{minHeight: "45vh"}} />
          </ModalBody>

        </ModalContent>
      </Modal>
    </>
  );
}